// extracted by mini-css-extract-plugin
export var chatHtmlText = "_t1-2";
export var chatLink = "_t1-0";
export var chatText = "_t1-1";